import React, { Fragment } from 'react';
import './investors.css';
import hub from '../../images/investors/hubBW.png';

const InvestInAutzuBot = ({ isMobile }) => {
  return (
    <div className="bottom-section">
      <div className="linear-background-bot">
        <div className="innerbox-investors">
          <div className="innertext">
            Engineered to manage and recharge electric rideshare vehicles.
          </div>
          <button
            className="innerbutton"
            onClick={() => window.open('mailto:investors@autzu.com')}>
            Invest in Autzu
          </button>
        </div>
        <div className='bot-img'>
          <img src={hub} className={isMobile ? 'hub-s' : 'hub'}/>
          Current Autzu Drivesharing hub in San Francisco.
      </div>
      </div>
    </div>
  );
};

export default InvestInAutzuBot;



// WEBPACK FOOTER //
// ./src/components/Investors/InvestInAutzuBot.js